import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'

export const selectAsset = createSelector(
  (state: RootState) => state,
  (state) => state.assets
)
